module.exports = __webpack_public_path__ + "img/tra.5112fc37.gif";